import { render, staticRenderFns } from "./menuLeft.vue?vue&type=template&id=09506fd6&lang=pug"
import script from "./menuLeft.vue?vue&type=script&lang=js"
export * from "./menuLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports